import {serverIncidentAPI} from 'features/server/api/serverIncidentAPI';
import {ILastIncidents} from 'entities/monitor';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IServerIncident from './ServerIncident/IServerIncident';

export const useLastServerIncidents = (limit: number): ILastIncidents<IServerIncident> => {
    const {data: pagination, isLoading, isFetching} = serverIncidentAPI.useGetServerIncidentsQuery(
        {limit},
        {pollingInterval: getPollingInterval()},
    );

    return {pagination, isLoading, isFetching};
};

export default useLastServerIncidents;
